import React from 'react';
import { clsx } from 'clsx';

import { Link } from '@/components/link';

type Props = {
  children?: React.ReactNode;
  className?: string;
  name: string;
  link: string;
  icon?: React.ElementType;
  exact?: boolean;
  type: 'inline' | 'stacked';
};

const TODO_IS_ACTIVE = false;
//clsx('border-teal-500 focus:border-teal-700', {
//       'text-gray-900': type === 'inline',
//       'border-teal-500 text-teal-700 bg-teal-50 focus:text-teal-800 focus:bg-teal-100': type === 'stacked',
//     })
export const NavigationItem: React.FC<Props> = ({ className, name, link, exact, type }) => (
  <Link
    href={link}
    className={clsx(
      'border-transparent font-medium focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out',
      {
        'inline-flex items-center px-1 pt-1 border-b-2 text-sm leading-5 text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700':
          type === 'inline',
        'mt-1 block pl-3 pr-4 py-2 border-l-4 text-base text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:text-gray-800 focus:bg-gray-50 sm:pl-5 sm:pr-6':
          type === 'stacked',
      },
      className
    )}
  >
    {name}
  </Link>
);
